import numeral from 'numeral';
import $ from 'jquery';
import Api from '../utilities/Api';

const BasketService = {
    add(productId, quantity) {
        return Api.post('/api/basket/add/', {
            quantity,
            product_id: productId
        });
    },
    update(productId, quantity) {
        return Api.post('/api/basket/update/', {
            quantity,
            product_id: productId
        });
    },

    formatPrice(price) {
        return numeral(price).format('0,0[.]00').split(',').join(' ');
    },

    updateHeaderCounter(count) {
        if (count > 0) {
            $('.header-cart__quantity').removeClass('hidden');
        } else {
            $('.header-cart__quantity').addClass('hidden');
        }
        $('.header-cart__quantity').text(count);
        $('.header-cart__quantity').addClass('header-cart__quantity--added');
        setTimeout(() => {
            $('.header-cart__quantity').removeClass('header-cart__quantity--added');
        }, 300);
    },

    render() {
        let points = 0;
        let total = 0;

        $('.products-table-item').each(function () {
            const itemPrice = +$(this).attr('data-price');
            const itemPoints = +$(this).attr('data-points');
            const itemQuantity = +$(this).attr('data-quantity');

            points += itemPoints * itemQuantity;
            total += itemPrice * itemQuantity;
        });

        $('.basket-result-item__value--points').text(this.formatPrice(points));
        $('.basket-result-item__value--total').text(this.formatPrice(total));
    }
};
export default BasketService;
